export function generateExpDate() {
    let expDate = new Date()
    expDate.setDate(expDate.getDate() + 1)
    return expDate;
}